import Vue from "vue";
import api from "./api";

Vue.prototype.$api = api;



// WEBPACK FOOTER //
// ./src/server/index.js